import * as React from 'react';
import { ImageAlignment, ImageFit } from '../../../types/image';
import { FieldLabelWUT } from '../../field-label/field-label-wut';
import { ImageComponentWUT } from '../../image-choice-field/image-component-wut';
import { classes } from './challenges-question-styles.st.css';
const DEFAULT_QUESTION_IMAGE_ASPECT_RATIO = 3 / 2;
export const ChallengesQuestionWut = props => {
  const {
    image,
    imagePlacement = 'bottom',
    imageResize = ImageFit.COVER,
    imageAlignment,
    labelId,
    htmlFor,
    ...fieldLabelProps
  } = props;
  const Tag = props.htmlFor ? 'label' : 'div';
  const questionElement = /*#__PURE__*/React.createElement(FieldLabelWUT, fieldLabelProps);
  const imageElement = image ? /*#__PURE__*/React.createElement("div", {
    className: classes.imageContainer
  }, /*#__PURE__*/React.createElement(ImageComponentWUT, {
    image: image,
    alt: props.imageAltText,
    aspectRatio: imageResize === 'cover' ? DEFAULT_QUESTION_IMAGE_ASPECT_RATIO : Math.max(image.width / image.height, DEFAULT_QUESTION_IMAGE_ASPECT_RATIO),
    imageAlignment: imageResize === ImageFit.COVER ? ImageAlignment.CENTER : imageAlignment,
    imageResize: imageResize
  })) : null;
  return /*#__PURE__*/React.createElement(Tag, {
    id: labelId,
    htmlFor: htmlFor,
    className: classes.root
  }, imagePlacement === 'top' ? imageElement : null, questionElement, imagePlacement === 'bottom' ? imageElement : null);
};
//# sourceMappingURL=challenges-question-wut.js.map